module.exports = __webpack_public_path__ + "img/dark-loader.9796c607.gif";